module.exports = __webpack_public_path__ + "static/menu_hero-16a5b3477cee3d1c4a926bd4fed41555.png";